import { EXLY_BACKEND_API_HOST } from "repoV2/constants/apis";
import { DISCOUNT_OFF_TYPES } from "repoV2/features/Listing/Listing.constants";

export const coupon_code_apis = {
    apply_code_on_listing: `${EXLY_BACKEND_API_HOST}/payments/exly/discounts/apply`,
};

/**
 * Discount off type comes as string only this api.
 * Rest all of the apis give data as numeric values as in `DISCOUNT_OFF_TYPES` enum.
 * So we use this constant to convert the data into something that is used in most of the places.
 */
export const DISCOUNT_OFF_TYPES_IN_APPLY_CODE_ON_LISTING_API = {
    Absolute: DISCOUNT_OFF_TYPES.ABSOLUTE,
    Percentage: DISCOUNT_OFF_TYPES.PERCENTAGE,
};
